import { Box, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material';

import type { AccountMode, BookingWizardData } from './types';

interface Props {
  booking: BookingWizardData;
  onBooking: (partial: Partial<BookingWizardData>) => void;
}

export function Step3Account({ booking, onBooking }: Props) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="subtitle2">Account setup</Typography>
      <RadioGroup
        value={booking.account_mode}
        onChange={(e) => onBooking({ account_mode: e.target.value as AccountMode })}
      >
        <FormControlLabel
          value="single"
          control={<Radio />}
          label="Single account — stored as the default; webhook URLs carry no account segment."
        />
        <FormControlLabel
          value="multi"
          control={<Radio />}
          label="Multi-account — a named account; the slug appears in the webhook URLs."
        />
      </RadioGroup>

      {booking.account_mode === 'multi' && (
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            label="Display name"
            size="small"
            value={booking.display_name}
            onChange={(e) => onBooking({ display_name: e.target.value })}
            sx={{ flex: 1 }}
          />
          <TextField
            label="Account slug"
            size="small"
            value={booking.slug}
            helperText="Lowercase; appears in webhook URLs. Cannot be changed later."
            onChange={(e) =>
              onBooking({ slug: e.target.value.toLowerCase().replace(/[^a-z0-9_-]/g, '') })
            }
            sx={{ flex: 1 }}
          />
        </Box>
      )}
    </Box>
  );
}
